import { actionCopyDa } from "./actionCopy";

export const diaryCopyDa = {
    diaries: "Dagbøger",
    diary: "Dagbog",
    diaryPeriod: "Dagbogsperiode",
    toDo: "Gøremål",
    results: "Resultater",
    toNow: "- Nu",
    edit: actionCopyDa.edit,
    change: "Skift",
    details: "Detaljer",
    deleteEntry: "Slet indtastning",
    done: actionCopyDa.done,
    next: actionCopyDa.next,
    save: actionCopyDa.save,
    saving: actionCopyDa.saving,
    cancel: actionCopyDa.cancel,
    date: "Dato",
    time: "Tidspunkt",
    noSteps: "Ingen trin.",
    step: "Trin",
    chooseStep: "Vælg et trin",
    currently: "I øjeblikket",
    general: "Generelt",
    procedureDetails: "Behandlingsdetaljer",
    hospitalReferenceNumber: "Hospitals referencenummer",
    hospitalNumber: "Hospitalsnummer",
    hospitalNumberDescription: "Hospitals referencenummer for alle spørgeskemaer.",
    enterHospitalNumber: "Angiv hospitalsnummer",
    startDate: "Startdato",
    procedureDate: "Behandlingsdato",
    referenceDate: "Referencedato",
    referenceDateDescription: "Datoen for injektionen, operationen eller anden behandling.",
    baselineDate: "Baselinedato",
    baselineDateDescription:
        "Datoen, som opfølgningen måles fra, f.eks. da patienten blev inkluderet i studiet. Spørgeskemaerne planlægges ud fra denne dato.",
    patientBaselineDate: "Startdato",
    patientBaselineDateDescription: "Datoen, som dine opfølgningsspørgsmål planlægges ud fra.",
    eventDateDescription: "Opfølgningsspørgeskemaerne planlægges ud fra denne dato.",
    patientEventDateDescription: "Dine opfølgningsspørgsmål planlægges ud fra denne dato.",
    endDate: "Slutdato",
    contactPerson: "Kontaktperson",
    contactPersonDescription: "Primær kontakt for denne dagbog. Tryk kopiér for at kopiere deres e-mailadresse.",
    loadingContact: "Indlæser kontakt...",
    side: "Side",
    anatomicArea: "Anatomisk område",
    questionnaireSide: "Spørgeskemaside",
    questionnaireSideDescription: "Hvilken side dette spørgeskema vedrører.",
    notSet: "Ikke angivet",
    trackerSettings: "Spørgeskemaindstillinger",
    consent: "Samtykke",
    consentForm: "Samtykkeerklæring",
    consentDetails: "Detaljer",
    openConsent: "Åbn samtykke",
    sign: "Underskriv",
    signed: "Underskrevet",
    signedAt: (date: string) => `Underskrevet ${date}`,
    requiresSignature: "Kræver underskrift",
    actionRequiredSignConsent: "Handling påkrævet: Underskriv samtykke",
    signConsentBeforeContinuing: (count: number) =>
        `Du skal underskrive følgende samtykkeerklæring${count > 1 ? "er" : ""}, inden du fortsætter:`,
    signConsentNow: "Underskriv samtykke nu",
    detailsStillNeed: "Oplysninger vi stadig har brug for",
    detailsStillNeedDescription:
        "Udfyld venligst disse oplysninger. Hvis siden stadig mangler, spørger vi på opsætningsskærmen.",
    injectionSide: "Injektionsside",
    injectionAnatomicArea: "Anatomisk injektionsområde",
    surgerySide: "Operationsside",
    shockwaveSide: "Stødbehandlingsside",
    shockwaveAnatomicArea: "Anatomisk stødbehandlingsområde",
    yourEntries: "Dine indtastninger",
    noDiary: "Ingen dagbog",
    noCompletedEntries: "Ingen afsluttede indtastninger endnu.",
    form: "formular",
    forms: "formularer",
    item: "element",
    items: "elementer",
    questionnaire: "Spørgeskema",
    questionnaires: "Spørgeskemaer",
    injection: "Injektion",
    surgery: "Operation",
    shockwave: "Stødbehandling",
    consultation: "Konsultation",
    procedure: "Behandling",
    procedures: (count: number) => `${count} behandlinger`,
    task: "opgave",
    tasks: "opgaver",
    toDoEmpty: "Du er helt ajour - intet at gøre lige nu.",
    blocked: "Venter på tidligere formularer",
    blockedEmpty: "Ingen formularer venter på tidligere trin.",
    formsLockedUntilConsentSigned: "Dine formularer låses op, når du har underskrevet det påkrævede samtykke.",
    completePreviousFormFirst: (formName: string) => `Udfyld ${formName} først`,
    doneEmpty: "Fuldførte trin vises her.",
    complete: "Udfyld",
    due: "Forfaldent",
    upToDate: "Ajour",
    allCaughtUp: "Helt ajour",
    formsNeedAttention: "Formularer kræver opmærksomhed",
    progress: "Fremskridt",
    completed: "Afsluttet",
    notNeeded: "Ikke nødvendig",
    dueNow: "Forfaldent nu",
    waiting: "Venter",
    locked: "Låst",
    lockedByEarlierEntry: "Låst - udfyld en tidligere indtastning først",
    lockedUntilPreviousFormComplete: (formName: string) => `Låst - udfyld ${formName} først`,
    availableLater: "Tilgængeligt senere",
    nextDue: "Næste forfald",
    dueOn: (date: string) => `Forfalder ${date}`,
    nextScheduledSentence: (formLabel: string, scheduleLabel: string, date: string) => {
        const schedule = scheduleLabel.trim();
        const due = date.trim();
        const timing = schedule ? ` for ${schedule.toLowerCase()}` : "";
        if (due) return `Din ${formLabel}${timing} forfalder næste gang ${due}.`;
        return `Din ${formLabel}${timing} forfalder næste gang.`;
    },
    noEntriesScheduled: "Ingen indtastninger planlagt endnu.",
    showLess: "Vis færre",
    showMore: (count: number) => `Vis mere (${count} ${count === 1 ? "tidspunkt mere" : "tidspunkter mere"})`,
    showAllTimings: (count: number) => `Vis alle ${count} tidspunkter`,
    expand: "Udvid",
    submitted: (completed: number, total: number) => `${completed} af ${total} indsendt`,
    submittedOn: (date: string) => `Indsendt ${date}`,
    noDataYet: "Ingen data endnu",
    noDataDescription: "Begynd at tilføje indtastninger for at se dine fremskridt over tid",
    notEnoughDataYet: "Ikke nok data endnu",
    notEnoughDataDescription: "For at se diagrammer skal der være mindst to indtastninger.",
    addEntry: "Tilføj indtastning",
    addEntryFor: (formSlug: string, timingLabel: string) => `Tilføj ${formSlug} ${timingLabel} indtastning`,
    addExtraScore: "Tilføj ekstra score",
    addExtraScoreTitle: "Tilføj en ekstra score",
    addExtraScoreDescription:
        "Dette er valgfrit. Fortsæt kun, hvis du vil registrere en ekstra måling, eller hvis du er blevet bedt om at tjekke ind.",
    addForm: "Tilføj formular",
    entryDue: (label: string) => `Din indtastning for ${label.toLowerCase()} er forfalden.`,
    nextEntryDueOn: (label: string, date: string) => `Din ${label.toLowerCase()}-indtastning er forfalden den ${date}.`,
    entriesDueForForm: (count: number) => `${count} forfaldne indtastninger for denne formular.`,
    formWithEntriesDue: (formName: string, entries: number) =>
        `${formName} har ${entries} ${entries === 1 ? "forfalden indtastning" : "forfaldne indtastninger"}. Dine øvrige formularer er ajour.`,
    formsWithEntriesDue: (forms: number, entries: number) =>
        `Du har ${forms} ${forms === 1 ? "formular" : "formularer"} med ${entries} ${
            entries === 1 ? "forfalden indtastning" : "forfaldne indtastninger"
        }.`,
    allFormsComplete: "Alle dine formularer er udfyldt.",
    allEntriesComplete: "Alle indtastninger er udfyldt",
    entriesDueNow: (count: number) => `${count} indtastninger forfalder nu`,
    completeYourEntry: (label: string) => `Udfyld din ${label.toLowerCase()}-indtastning`,
    questionnaireDueNow: "Spørgeskema forfalder nu",
    nextEntryLabel: (label: string) => `Næste indtastning: ${label}`,
    waitingForNextEntry: "Venter på næste indtastning",
    readyLabel: (label: string) => `Klar: ${label}`,
    readyToComplete: "Klar til at udfylde",
    reminderText: "Vi sender dig en SMS, når det er forfaldent.",
    reminderEmail: "Vi sender dig en e-mail, når det er forfaldent.",
    reminderTextAndEmail: "Vi sender dig en SMS og en e-mail, når det er forfaldent.",
    reminderNone:
        "Aktivér SMS- eller e-mailpåmindelser i dine indstillinger, hvis du gerne vil have et hint, når det er forfaldent.",
    entrySubmitted: "Indtastning indsendt.",
    completeWithCareTeam: "Udfyldt og afventer gennemgang.",
    formNumber: (index: number) => `Formular ${index}`,
    dateOfProcedure: (phrase: string) => `Dato for ${phrase}`,
    wrongDate: "Forkert dato?",
    editHere: "Rediger her",
    showAnswers: "Vis svar",
    hideAnswers: "Skjul svar",
    showAnswersDescription: "Se svar, eller tryk på Skift ved et tidspunkt for at opdatere svar",
    entryCountLabel: (count: number) => (count === 1 ? "1 indtastning" : `${count} indtastninger`),
    timing: "Tidspunkt",
    referredBy: (name: string) => `Henvist af: ${name}`,
    performedBy: (name: string) => `Udført af: ${name}`,
    method: (method: string) => `Metode: ${method}`,
    injectionDetails: "Injektionsdetaljer",
    unknown: "Ukendt",
    noDateSpecified: "Ingen dato angivet",
    noInjectionDetails: "Ingen injektionsdetaljer angivet.",
    sideNotSpecified: "Side ikke angivet",
    areaNotSpecified: "Område ikke angivet",
    siteNotSpecified: "Lokalisation ikke angivet",
    substanceNotSpecified: "Substans ikke angivet",
    blankAnswer: "Ikke udfyldt",
    listEmptyTitle: "Ingen dagbøger endnu",
    listEmptyDescription: "Dagbøger oprettet til dig vises her",
    listCheckAgain: "Tjek igen",
    listNeedsAttention: "Kræver din opmærksomhed",
    listNeedsAttentionDescription: "Dagbøger med formularer, der venter på din næste indtastning.",
    listOngoing: "I gang",
    listOngoingDescription: "Dagbøger der er i gang eller venter på din første indtastning.",
    listUpToDateDescription: "Dagbøger i gang uden forfaldne indtastninger lige nu.",
    listNoOngoing: "Ingen igangværende dagbøger i øjeblikket",
    listCompletedDescription: "Dagbøger der er afsluttet (indsamler ikke længere indtastninger).",
    listNoCompleted: "Ingen afsluttede dagbøger endnu",
    listOpenDiary: "Åbn dagbog",
    listReviewDiary: "Gennemse dagbog",
};
